var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16667 16.3333H7.5V8.16667H5.16667V16.3333ZM9.83333 16.3333H12.1667V4.66667H9.83333V16.3333ZM14.5 16.3333H16.8333V11.6667H14.5V16.3333ZM2.83333 21C2.19167 21 1.64236 20.7715 1.18542 20.3146C0.728472 19.8576 0.5 19.3083 0.5 18.6667V2.33333C0.5 1.69167 0.728472 1.14236 1.18542 0.685417C1.64236 0.228472 2.19167 0 2.83333 0H19.1667C19.8083 0 20.3576 0.228472 20.8146 0.685417C21.2715 1.14236 21.5 1.69167 21.5 2.33333V18.6667C21.5 19.3083 21.2715 19.8576 20.8146 20.3146C20.3576 20.7715 19.8083 21 19.1667 21H2.83333ZM2.83333 18.6667H19.1667V2.33333H2.83333V18.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.55e00a60d8258f2c2c98cedf1561117c.svg";
export { ForwardRef as ReactComponent };